<script>
import features from "@/configs/features";

export default {
  computed: {
    features: () => features,
    year: () => new Date().getFullYear(),
  },
};
</script>

<template>
  <div>
    <h3 class="text-center text-airbnbRed text-base font-semibold">
      Reversement de la taxe de séjour {{ year }}
    </h3>
    <br />
    <br />
    <p>
      Le versement correspondant à la période de collecte 1er novembre {{ year - 1 }} – 30 avril {{ year }} va être
      effectué fin juin {{ year }} et celui correspondant à la période de collecte 1er mai {{ year }} – 31 octobre {{
        year }} va être effectué fin décembre {{ year }}.
      <br />
      <br />
      Ce versement sera effectué directement aux villes, à l’aide des
      informations bancaires mises à la disposition des plateformes par la
      DGFIP. Airbnb ne saurait être tenue responsable de possibles erreurs dans
      les coordonnées bancaires.
      <br />
      <br />
      A cette date, les fichiers de données seront également mis à disposition
      des villes dans leur espace sécurisé sur ce site. Merci de vous inscrire
      sur le présent site (section Mon espace “Mairie”) pour accéder aux
      informations de collecte mises à la disposition des communes et des EPCI.
    </p>
    <br />
  </div>
</template>

<style></style>
